'use strict';

const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('schaffrath/components/stores'));
    processInclude(require('schaffrath/components/appointment'));
    processInclude(require('schaffrath/components/loadVideos'));
    processInclude(require('schaffrath/components/carouselPreviewImages'));
    processInclude(require('schaffrath/components/productDetailQuickView'));
    processInclude(require('wishlists/product/wishlist'));
    processInclude(require('./carousel'));
});
